import type { Event } from "@viagogo/cx-sentry";
import { ComponentNames } from "src/shared/utils/sentry/ComponentNames";
import { SentryTags } from "../SentryTags";

const SAMPLE_RATE = 0.25; // 25%

/**
 * Event processor that samples events published from the MapboxContainer component
 * This exception is tagged with ComponentNames.MAPBOX for SentryTags.COMPONENT.
 */
export const mapboxContainerEventProcessor = (event: Event) => {
  try {
    if (event.tags?.[SentryTags.COMPONENT] === ComponentNames.MAPBOX) {
      return Math.random() < SAMPLE_RATE
        ? event // Keep the event (25% chance)
        : null; // Drop the event (75% chance)
    }
    return event;
  } catch {
    return event; // In case of any error, return the event unmodified
  }
};
